// src/components/AdResultModal.js
import React from 'react';
import './AdResultModal.css';

/**
 * مودال نتيجة نشر الإعلان (نجاح / فشل) — بدون توليد صورة.
 */
const AdResultModal = ({
  isSuccess,
  message,
  onClose,
  currentLanguage,
  getLocalizedText,
}) => {
  const t = (ar, en) => getLocalizedText(ar, en);

  return (
    <div className="ad-result-modal-overlay">
      <div
        className={`ad-result-modal ${isSuccess ? 'success' : 'error'}`}
        dir={currentLanguage === 'ar' ? 'rtl' : 'ltr'}
      >
        <div className="ad-result-content">
          <button
            className="ad-result-close-btn"
            onClick={onClose}
            aria-label={t('إغلاق', 'Close')}
          >
            ×
          </button>

          <div className="ad-result-emoji">
            {isSuccess ? '✅' : '❌'}
          </div>

          <h2 className="ad-result-title">
            {isSuccess
              ? t('تم نشر الإعلان بنجاح!', 'Ad Posted Successfully!')
              : t('فشل في نشر الإعلان', 'Failed to Post Ad')}
          </h2>

          <p className="ad-result-message">
            {message || (
              isSuccess
                ? t(
                    'سيظهر إعلانك الآن في القائمة ويمكنك معاينته من منشوراتك.',
                    'Your ad is now live and can be previewed from your posts.'
                  )
                : t(
                    'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقًا.',
                    'An unexpected error occurred. Please try again later.'
                  )
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdResultModal;
